import { render, staticRenderFns } from "./RegistroNecessidade.vue?vue&type=template&id=134852a6&scoped=true"
import script from "./RegistroNecessidade.vue?vue&type=script&lang=js"
export * from "./RegistroNecessidade.vue?vue&type=script&lang=js"
import style0 from "./RegistroNecessidade.vue?vue&type=style&index=0&id=134852a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134852a6",
  null
  
)

export default component.exports